import React from 'react';
import { FlickeringBeta } from './FlickeringBeta';
import { Box } from '@mui/material';

type Props = {
  handleLogoClick: () => void;
  small?: boolean;
};

export const Logo = ({ handleLogoClick, small }: Props) => {
  return (
    <div
      style={{
        display: 'flex',
        cursor: 'pointer',
      }}
    >
      {!small ? (
        <Box
          sx={{
            position: 'absolute',
            zIndex: 99,
            top: '-20px',
            right: '-20px',
          }}
        >
          <FlickeringBeta />
        </Box>
      ) : null}
      <img
        alt="PAR"
        src="/glowing-0.svg"
        className={small ? 'par-logo-dark-small' : 'par-logo-dark-crooked'}
        onClick={handleLogoClick}
      ></img>
    </div>
  );
};
